import classNames from 'classnames';

import { ChevronBoldIcon } from '../../icons';
import Badge, { BadgeVariant } from '../Badge';

import styles from './_index.module.scss';

export interface BannerButtonProps extends Omit<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  'children'
> {
  badgeLabel?: React.ReactNode;
  className?: string;
  'data-testid'?: string;
  text: React.ReactNode;
}

const BannerButton = ({
  'aria-label': ariaLabel,
  badgeLabel = null,
  className,
  'data-testid': dataTestId = 'banner-button',
  text,
  type = 'button',
  ...props
}: BannerButtonProps) => {
  const fallbackLabel = [badgeLabel, text]
    .filter((value) => typeof value === 'string' || typeof value === 'number')
    .join(' ');

  return (
    <button
      aria-label={ariaLabel || fallbackLabel || undefined}
      className={classNames(styles['banner-button'], className)}
      data-testid={dataTestId}
      type={type}
      {...props}
    >
      {badgeLabel ? (
        <Badge
          className={styles['banner-button-badge']}
          data-testid={`${dataTestId}-badge`}
          label={badgeLabel}
          variant={BadgeVariant.info}
        />
      ) : null}
      <span className={styles['banner-button-text']}>{text}</span>
      <span
        aria-hidden="true"
        className={styles['banner-button-icon']}
        data-testid={`${dataTestId}-icon`}
      >
        <ChevronBoldIcon />
      </span>
    </button>
  );
};

export default BannerButton;
